import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

  export const getAllFeedbackProfiles = async (pageNumber=1, pageSize=1000) => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(
        `${apiendpoints.GET_ALL_FEEDBACKS}?pageNumber=${pageNumber}&pageSize=${pageSize}`
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };
